import { DateText } from '@legacy/components/ui-components/DateText';
import { Icon } from '@legacy/components/ui-components/Icon';
import { Link } from '@legacy/components/ui-components/Link';
import { IMilestonesEntities } from '@legacy/apis/types/milestonesAPI';
import { Stack, Typography } from '@legacy/components/mui-components';
import { legacyRoutes } from '@/constants/legacyRoutes';
import styles from './FeedItems.module.scss';
import { useHasNewProjectManagement } from '@/hooks/featureFlags';
import { routes } from '@/constants/routes';

interface IMilestoneFeedItemProps {
  items?: IMilestonesEntities[];
}

export const FeedItems = ({ items }: IMilestoneFeedItemProps) => {
  const hasNewProjectManagement = useHasNewProjectManagement();

  return (
    <Stack gap={4} data-automation-id="MilestonesResults">
      {items?.map(
        ({
          name,
          projectNameFormatted,
          projectId,
          milestoneId,
          dueDate,
          isOverdue,
        }) => (
          <Stack
            direction="row"
            alignItems="top"
            gap={0}
            key={milestoneId}
            data-automation-id="MilestonesMilestone"
          >
            <div>
              <Icon iconName="milestone" tone="warning" />
            </div>
            <div className={styles.itemContent}>
              <Stack gap={1}>
                <Stack gap={1}>
                  <Typography
                    variant="h4"
                    component="h3"
                    fontWeight={500}
                    data-automation-id={`MilestonesMilestoneName${milestoneId}`}
                  >
                    <Link
                      href={
                        hasNewProjectManagement
                          ? routes.projects.planning(projectId)
                          : legacyRoutes.projectManagement.index(projectId)
                      }
                      data-automation-id={`MilestonesMilestoneLink${milestoneId}`}
                    >
                      {name}
                    </Link>
                  </Typography>
                  <Typography
                    sx={{ opacity: 0.75 }}
                    variant="label"
                    component="p"
                    data-automation-id={`MilestonesProjectName${milestoneId}`}
                  >
                    <Stack
                      component="span"
                      direction="row"
                      alignItems="top"
                      gap={0.5}
                    >
                      <Icon iconName="project" size="small" />
                      {projectNameFormatted}
                    </Stack>
                  </Typography>

                  <Typography
                    sx={{ opacity: isOverdue ? 1 : 0.75 }}
                    variant="label"
                    component="p"
                    color={isOverdue ? 'error' : undefined}
                    data-automation-id={`MilestonesDueDate${milestoneId}`}
                  >
                    <Stack
                      component="span"
                      direction="row"
                      alignItems="top"
                      gap={0.5}
                    >
                      <Icon iconName="calendar" size="small" />

                      <DateText value={new Date(dueDate)} />
                    </Stack>
                  </Typography>
                </Stack>
              </Stack>
            </div>
          </Stack>
        ),
      )}
    </Stack>
  );
};
